module.exports = __webpack_public_path__ + "img/Icon_evaluation_process_hover.ed214096.svg";